<template>
  <div class="vx-row">
    <div class="vx-col w-full flex flex-col">
      <!-- <vs-button
        color="danger"
        type="filled"
        class="mb-4 self-end"
        size="medium"
        @click="testTrigger"
      >Test Trigger</vs-button> -->
      <vs-alert title="Informasi" class="my-5" color="danger">
        Menu ini merupakan menu yang berisi informasi terkait dengan indikasi kejadian tindak korupsi di lingkungan MPP Lombok Tengah.
      </vs-alert>
      <div class="w-full">
        <global-new-wrapper
          :loading="loading"
          :loadingType="'OneLine'"
          :loadingList="5"
          :empty="track.data.length == 0"
          :error="error"
        >
          <global-table
            @reloadData="handleOnReloadData($event)"
            :currentPage="track.current_page"
            :totalPage="track.last_page"
          >
            <template #thead>
              <global-th width="20px">No.</global-th>
              <global-th>Kode Registrasi</global-th>
              <global-th>Waktu Kejadian</global-th>
              <global-th>Nomor Handphone</global-th>
              <global-th>Lokasi</global-th>
            </template>
            <template #tbody>
              <global-tr v-for="(item, index) in track.data" :key="index">
                <global-td>{{(track.current_page-1) * track.per_page + index + 1}}</global-td>
                <global-td>
                  {{item.registration_code}}
                </global-td>
                <global-td>
                  {{item.created_at}}
                </global-td>
                <global-td>{{item.phone}}</global-td>
                <global-td>
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-map"
                      color="danger"
                      class="mb-3"
                      @click="showMap(item.geolocation)"
                      > Lihat Lokasi
                    </vs-button>
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-share"
                      color="danger"
                      @click="shareLocation(item.geolocation, item.registration_code)"
                      > Share lokasi
                    </vs-button>
                </global-td>
              </global-tr>
            </template>
          </global-table>
        </global-new-wrapper>

        <ez-modal class="holamundo" title :active.sync="popupMap" classModal="w-2/3">
          <div class="vx-row m-0">
            <div class="vx-col p-5 w-full text-center text-3xl font-semibold text-danger">
              <strong>Detail lokasi kejadian indikasi tindakan KORUPSI</strong>
            </div>
            <div class="vx-col w-full text-center">
              <TrackMap :coordinate="selectedCoordinate"/>
            </div>
          </div>
        </ez-modal>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import ComplaintStatusChip from "@/components/chip/ComplaintStatusChip";
import TrackMap from "./TrackMap";
import alertSound from "@/assets/sound/alert.mp3";

export default {
  components: {
    "v-select": vSelect,
    Datepicker,
    ComplaintStatusChip,
    TrackMap
  },
  data() {
    return {
      loading: true,
      error: false,
      track: {
        data: []
      },
      pagination: {
        currentPage: 1,
        perPage: 10
      },
      popupMap: false,
      selectedCoordinate: {lat:-8.603794454696615, lng:115.17666547480198}
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      let data = {
        page: this.pagination.currentPage
      };

      this.$http
      .get("/app/secure/track/data", {params : {...data}})
      .then(response => {
        this.track = response.data.data.track;
        this.loading = false;
      })
      .catch(e => {
        this.parseError(e);
      })
      .finally(() => {
        this.$vs.loading.close();
      });
    },
    handleOnReloadData(currentPage) {
      this.pagination.currentPage = currentPage;
      this.getData();
    },
    showMap(coordinate){
      this.selectedCoordinate = JSON.parse(coordinate);
      this.popupMap = true;
    },
    shareLocation(geolocation, registrationCode){
      let json = JSON.parse(geolocation);
      let mapsUrl = `http://www.google.com/maps/place/${json.lat},${json.lng}`;
      let waUrl = `whatsapp://send?text=Berikut link map detail kejadian indikasi korupsi dengan kode registrasi ${registrationCode} : ${mapsUrl}`;
      
      window.open(waUrl);
    },
    testTrigger(){
      let audio = new Audio(alertSound);
      audio.play();
      this.$http
      .get("/app/secure/track/test-trigger")
      .catch(e => {
        this.parseError(e);
      })
      .finally(() => {
        this.$vs.loading.close();
      });
    }
  },
};
</script>